import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// popupus
import CreateProject from "./CreateProject";

// styles and images
import "./Dashboard.css";
import Add from "../../assets/add.svg";

// internal hooks
import { useGetProjectDD } from "../../hooks/useGetProjectDD";

// components
import ProjectListAlt from "./ProjectListAlt";
import ProjectFilter from "./ProjectFilter";

// store
import { dbDataStore, userStore } from "../../store/Store";

export default function Dashboard() {
  // global state
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const projectData = dbDataStore((dbData) => dbData.projectData);
  
  // triggers
  const [isTriggered, setIsTriggered] = useState(false);

  // state
  const [visibleProjects, setVisibleProjects] = useState(null);
  const { dropDowns } = useGetProjectDD();
  const navigate = useNavigate();

  useEffect(() => {
    if (projectData && !projectData.error) {
      let vis = [];
      projectData.forEach((p) => {
        if (!p.archived) {
          vis.push(p);
        }
      });
      setVisibleProjects(vis);
    }
  }, [projectData, navigate]);

  return (
    JwtToken && (
      <div className="container-fluid">
        <div className="d-flex justify-content-between dashboard-header">
          <h1>Projects</h1>
          <div className="button-div">
            <img
              src={Add}
              alt="add"
              onClick={() => setIsTriggered(true)}
              className="project-delete-image"
            />
          </div>
        </div>
        {isTriggered && (
          <CreateProject
            setIsTriggered={setIsTriggered}
            isTriggered={isTriggered}
            dropDowns={dropDowns}
          />
        )}
        {projectData && !projectData.error ? (
          <div className="row g-2">
            <ProjectFilter
              setVisibleProjects={setVisibleProjects}
              projectDocs={projectData}
            />
            <ProjectListAlt projectDocs={visibleProjects} />
          </div>
        ) : (
          !projectData && (
            <p className="no-docs-added">No Projects Have Been Added</p>
          )
        )}
      </div>
    )
  );
}
